module.exports = __webpack_public_path__ + "static/media/wallet.3b94edc9.svg";